module.exports = __webpack_public_path__ + "img/game_detail_lucky5_regular.5aef8635.jpg";